import { useRef, useState } from "react";
import Tabs from "../../components/tabs";
import Button from "../../components/button";
import styles from "./styles.module.css";
import UserActions from "./user-actions";
import Dags from "./dags";
import { exportDagLogsCSV, exportUserActionLogs } from "../../services/logs";
import { toast } from "react-toastify";

const Logs = () => {
  const [selectedTab, setSelectedTab] = useState("user-actions");
  const [isExporting, setIsExporting] = useState(false);
  const userActionsRef = useRef(null);
  const dagsRef = useRef(null);

  const handleTabClick = (value) => {
    setSelectedTab(value);
  };

  const handleExportData = async () => {
    if (isExporting) return;

    setIsExporting(true);
    try {
      if (selectedTab === "user-actions") {
        const filters = userActionsRef.current?.getExportParams?.() ?? {};
        await exportUserActionLogs(filters);
      } else if (selectedTab === "dags") {
        const filters = dagsRef.current?.getExportParams?.() ?? {};
        await exportDagLogsCSV(filters);
      }
      toast.success("Datos exportados");
    } catch (error) {
      toast.error("Error al exportar los logs");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.title}>Logs de la aplicación</h3>
        </div>
        <div className={styles.tabs}>
          <Tabs
            tabs={[
              { label: "Acciones de usuarios", value: "user-actions" },
              { label: "DAGs", value: "dags" },
            ]}
            selectedTab={selectedTab}
            onChange={handleTabClick}
          />
          <Button
            variant="outline"
            onClick={handleExportData}
            disabled={isExporting}
          >
            Exportar datos
          </Button>
        </div>
        <div className={styles.content}>
          {selectedTab === "user-actions" ? (
            <UserActions ref={userActionsRef} />
          ) : (
            <Dags ref={dagsRef} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Logs;
